function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3911",
  transform: "translate(3.597 36.088)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3908"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3907"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_820",
  d: "M14.931-32.34H1.993v-1.684a.562.562 0 0 0-.561-.564.563.563 0 0 0-.4.165l-3.375 3.375a.562.562 0 0 0 0 .8l3.375 3.374a.563.563 0 0 0 .8 0 .561.561 0 0 0 .164-.4v-1.687h12.935a.562.562 0 0 0 .562-.562v-2.25a.56.56 0 0 0-.557-.566z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_3910"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3909"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_821",
  d: "M15.329-22.047l-3.375-3.376a.563.563 0 0 0-.8 0 .563.563 0 0 0-.165.4v1.684H-1.944a.562.562 0 0 0-.562.563v2.25a.561.561 0 0 0 .562.562h12.937v1.688a.562.562 0 0 0 .562.563.564.564 0 0 0 .4-.164l3.375-3.375a.563.563 0 0 0-.001-.795z"
}))));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_2317",
  fill: "none",
  d: "M0 0H20V20H0z"
});
var SvgTransferJournal = function SvgTransferJournal(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_261_1",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTransferJournal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transfer-journal.06b8f321.svg";
export { ForwardRef as ReactComponent };